import { render, staticRenderFns } from "./record_details.vue?vue&type=template&id=bbc62a60&"
import script from "./record_details.vue?vue&type=script&lang=js&"
export * from "./record_details.vue?vue&type=script&lang=js&"
import style0 from "./record_details.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports